@for (alert of alerts; track $index) {
<div  class="row {{cssClass(alert)}}">
 <div class="col-9"><span [innerHTML]="alert.message"></span></div>
  <div class="col-3" style="text-align:right"> 
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="removeAlert(alert)"></button>
  </div>
</div>
}

